import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { SimpleLoading } from "../../pures";
import { NIL as NIL_UUID } from 'uuid';
import "./collaborators-list.css";

/* === Dialog component form signer === */
const DialogCollaboratorsContainer = (props) => {
  const { t } = useTranslation();

  const containerIconRequestErrorStyles = {
    fontSize: "50px",
    color: "#E63B31",
  };

  const containerInputStyle = {
    marginBottom: "14px",
    lineHeight: 1,
    maxWidth: "100%",
  };

  const userContractTypesRoles = [
    {
      description: "Sin acceso",
      display: true,
      id: NIL_UUID,
      name: "Sin acceso",
    },
    {
      description: "Administrador",
      display: true,
      id: process.env.REACT_APP_GRC_CONTRACT_ROLE_ID_ADMIN,
      name: "Administrador",
    },
    {
      description: "Abogado",
      display: true,
      id: process.env.REACT_APP_GRC_CONTRACT_ROLE_ID_MANAGER,
      name: "Abogado",
    },
    {
      description: "Cliente",
      display: true,
      id: process.env.REACT_APP_GRC_CONTRACT_ROLE_ID_MEMBER,
      name: "Cliente",
    },
    {
      description: "Vendedor",
      display: true,
      id: process.env.REACT_APP_GRC_CONTRACT_ROLE_ID_SELLER,
      name: "Vendedor",
    },
  ];

  const userDocsTypesRoles = [
    {
      description: "Sin acceso",
      display: true,
      id: "0",
      name: "Sin acceso",
    },
    {
      description: "Suscriptor",
      display: true,
      id: process.env.REACT_APP_GRC_DOCS_ROLE_ID_SUSCRIBER,
      name: "Suscriptor",
    },
    {
      description: "Usuario",
      display: true,
      id: process.env.REACT_APP_GRC_DOCS_ROLE_ID_USER,
      name: "Usuario",
    },
  ];

  let dialogCollaboratorWidth = props.loadingComponent ? 500 : 620;
  let dialogCollaboratorHeight = props.loadingComponent ? 430 : 520;

  return (
    <div style={props.showErrorDomain === true ? { display: "none" } : null}>
      <Dialog
        width={dialogCollaboratorWidth}
        height={dialogCollaboratorHeight}
        className="dialogCollaboratorsContainer-dialog"
        title={
          props.buttonType === 0
            ? "Creación de usuario"
            : "Editar usuarios"
        }
        onClose={!props.saveError ? props.cancel : props.cancelError}
      >
        {props.loadingComponent && (
          <div>
            <SimpleLoading />
          </div>
        )}

        {!props.saveError && !props.loadingComponent && (
          <form>
            <div className="dialogCollaboratorsContainer-form">
              <div className="dialogCollaboratorsContainer-descriptionGrey">
                {props.userType.map((prop) => {
                  return (
                    <p className="dialogCollaboratorsContainer-div-leyend-p">
                      <span className="dialogCollaboratorsContainer-leyend-p-span">
                        {prop.name}:
                      </span>{" "}
                      {prop.description}
                    </p>
                  );
                })}
              </div>
              <div className="dialogCollaboratorsContainer-body-dialog">
                <div className="dialogCollaboratorsContainer-input-container">
                  <Label className="dialogCollaboratorsContainer-label">
                    {t("dialogCollaborators.email")}
                  </Label>
                  <Input
                    className="dialog-collaborator-k-textbox"
                    width="100%"
                    type="email"
                    name="email"
                    disabled={props.buttonType === 0 ? false : true}
                    minLength={2}
                    value={props.userInEdit.email || ""}
                    onChange={props.onDialogInputChange}
                    component={props.validateInput}
                  />
                  {props.errorCurrentEmail === true ? (
                    <span className="hint-message-error">
                      {props.messageErrorCurrentEmail}
                    </span>
                  ) : null}
                </div>
                {props.buttonType === 0 ? null : (
                  <Fragment>
                    <div className="dialogCollaboratorsContainer-input-container">
                      <Label className="dialogCollaboratorsContainer-label">
                        {t("dialogCollaborators.name")}
                      </Label>
                      <Input
                        // className="dialog-collaborator-k-textbox"
                        type="name"
                        name="name"
                        disabled={props.buttonType === 0 ? false : true}
                        minLength={2}
                        value={props.userInEdit.firstName || ""}
                        onChange={props.onDialogInputChange}
                        component={props.validateInput}
                      />
                      {props.errorCurrentName === true ? (
                        <span className="hint-message-error">
                          {props.messageErrorCurrentName}
                        </span>
                      ) : null}
                    </div>
                    <div className="dialogCollaboratorsContainer-input-container">
                      <Label className="dialogCollaboratorsContainer-label">
                        {t("dialogCollaborators.LastName")}
                      </Label>
                      <Input
                        // className="dialog-collaborator-k-textbox"
                        type="lastName"
                        name="lastName"
                        disabled={props.buttonType === 0 ? false : true}
                        minLength={2}
                        value={props.userInEdit.firstLastName || ""}
                        onChange={props.onDialogInputChange}
                        component={props.validateInput}
                      />
                      {props.errorCurrentLastName === true ? (
                        <span className="hint-message-error">
                          {props.messageErrorCurrentLastName}
                        </span>
                      ) : null}
                    </div>
                  </Fragment>
                )}
                <div className="dialogCollaboratorsContainer-input-container">
                  <Label className="dialogCollaboratorsContainer-label">
                    {t("dialogCollaborators.signerType")}
                  </Label>
                  <ComboBox
                    className="dialogCollaboratorsContainer-combo"
                    type="text"
                    name={"userTypeSelected"}
                    textField={"name"}
                    value={
                      props.userInEdit.userTypeSelected ||
                      props.userInEdit.userType ||
                      ""
                    }
                    onChange={props.onDialogInputChange}
                    data={props.userType}
                  //required={true}
                  />
                </div>
                {props.inputValidate && (
                  <span className="hint-message-error">
                    {t("dialogCollaborators.errorSend")}
                  </span>
                )}
              </div>
              {props.activeComboGrcContracts === true ?
                <div className="dialogCollaboratorsContainer-input-container-combo-modules">
                  <Label className="dialogCollaboratorsContainer-label">
                    {t("dialogCollaborators.contractsTypeUser")}
                  </Label>
                  <ComboBox
                    placeholder="Sin acceso"
                    className="dialog-collaborator-k-combobox"
                    type="text"
                    name={"userContractTypes"}
                    textField={"name"}
                    value={props.userInEdit.userContractTypes ||
                      props.userInEdit.roleContractType || ""}
                    onChange={props.onDialogInputChange}
                    data={userContractTypesRoles}
                  />
                </div>
                : null}

              {props.activeComboGrcDocs === true ?
                <div className="dialogCollaboratorsContainer-input-container-combo-modules">
                  <Label className="dialogCollaboratorsContainer-label-boveda">
                    {t("dialogCollaborators.docsTypeUser")}
                  </Label>
                  <ComboBox
                    placeholder="Sin acceso"
                    className="dialog-collaborator-k-combobox"
                    type="text"
                    name={"userDocsTypes"}
                    textField={"name"}
                    value={props.userInEdit.userDocsTypes || props.userInEdit.roleDocsType || ""}
                    onChange={props.onDialogInputChange}
                    data={userDocsTypesRoles}
                  />
                </div>
                : null}

              <div
                item="true"
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="dialogCollaboratorsContainer-btns-container"
              >
                <button
                  className="dialogCollaboratorsContainer-cancel"
                  onClick={props.cancel}
                >
                  {t("button.cancel")}
                </button>
                <button
                  className="dialogCollaboratorsContainer-accept-collaborator"
                  type="submit"
                  onClick={!props.errorCurrentEmail && (e => props.onSubmit(e))}
                  disabled={props.disableUserButton}
                >
                  {t("button.save")}
                </button>
              </div>
            </div>
          </form>
        )}
        {props.saveError && (
          <div>
            <p className="dialogCollaboratorsContainer-error-p-icon">
              <span
                style={containerIconRequestErrorStyles}
                className="k-icon k-i-close-circle k-i-x-circle"
              ></span>
            </p>
            <p className="dialogCollaboratorsContainer-error-p-message">
              {t("dialogSignRequestPure.AnErroSaveCollaborator")}
            </p>
            <div className="dialogCollaboratorsContainer-p-group-buttons">
              <button
                onClick={props.cancelError}
                className="dialogCollaboratorsContainer-back"
              >
                {t("signatureRequestDetailView2.buttonBack")}
              </button>
            </div>
          </div>
        )}
      </Dialog>
    </div>
  );
};

export { DialogCollaboratorsContainer as default };
